import { exchangeMethods, preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { shouldHaveOtherProductVariants } from '@/configuration/pages/ConfigurationPage/helpers'

import { recommendationOptions } from './constants'

export const shouldRenderExchangeRecommendationSelector = ({
  provider,
  configurationPreferences,
  allowedPreferences,
  allowedExchangeMethods,
  externalConnectedGateway,
}) => {
  return (
    shouldHaveOtherProductVariants(
      provider,
      configurationPreferences?.allowed_exchange_methods,
      externalConnectedGateway
    ) &&
    allowedPreferences.includes(preferences.productVariantExchangeRecommendationType) &&
    allowedExchangeMethods.includes(exchangeMethods.otherProductVariants)
  )
}

export const getRecommendationOptions = (availableRecommendationTypes, t) => {
  return recommendationOptions
    .filter(option => availableRecommendationTypes?.includes(option.value))
    .map(option => ({ ...option, label: t(option.label) }))
}
